import { cn } from '@louez/utils'

interface LogoProps {
  className?: string
  width?: number
  height?: number
}

export function Logo({ className, width = 104, height = 24 }: LogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 104 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-foreground', className)}
    >
      <rect width="24" height="24" rx="6" fill="#1f54dd" />
      <path
        d="M6 7.5C6 6.67 6.67 6 7.5 6H16.5C17.33 6 18 6.67 18 7.5V19H14.5V10H9.5V19H6V7.5Z"
        fill="white"
      />
      <text
        x="32"
        y="17"
        fill="currentColor"
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontWeight="800"
        fontSize="15"
        letterSpacing="0.08em"
      >
        ПРОКАТ
      </text>
    </svg>
  )
}

// Icon version (the "П" from Прокат) for favicon and small spaces
export function LogoIcon({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-foreground', className)}
    >
      <path
        d="M7 8.5C7 7.11929 8.11929 6 9.5 6H22.5C23.8807 6 25 7.11929 25 8.5V26H20V11H12V26H7V8.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
